import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import InstagramIcon from '@mui/icons-material/Instagram';
import TwitterIcon from '@mui/icons-material/Twitter';
import CodeIcon from '@mui/icons-material/Code';
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import {Link} from 'react-router-dom'
import {React} from 'react'
import Resume from './NilutpalBaruah_CV.pdf'
import "./Nav.css"
function NavBar() {
  return (
    <Navbar className='nav' collapseOnSelect expand="lg" bg="dark" variant="dark">
      <Container>
        <Navbar.Brand href="#home">NilutpalBaruah</Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="me-auto">
          <Nav.Link  as={Link} to="/" >Home</Nav.Link>
          <Nav.Link  as={Link} to="/About" >About</Nav.Link>
            <Nav.Link href="#blog" onClick={()=>alert("Will be coming soon!")}>Blog</Nav.Link>
            <NavDropdown title="Profiles" className='opa' id="collasible-nav-dropdown">
              <NavDropdown.Item href="https://leetcode.com/Nilotpal_38/">
                <CodeIcon/>
                {' '} LeetCode</NavDropdown.Item>
              <NavDropdown.Item href="https://github.com/nilutpalbr">
                <GitHubIcon/>
                {' '}GitHub
              </NavDropdown.Item>
              <NavDropdown.Item href="https://www.instagram.com/nilotpalbarua/?hl=en">
               <InstagramIcon/>
               {' '} Instagram</NavDropdown.Item>
              <NavDropdown.Item />
              <NavDropdown.Item href="https://www.linkedin.com/in/nilutpal-baruah-b448a01b8/">
                <LinkedInIcon/>
                {' '}LinkedIn
              </NavDropdown.Item>
              <NavDropdown.Item href="https://twitter.com/Nilotpal6317670">
                <TwitterIcon/> {' '}
                Twitter
              </NavDropdown.Item>
            </NavDropdown>
          </Nav>
          <Nav className='resume'>
          <Nav.Link  as={Link} to="/Projects" >Projects</Nav.Link>

           <Nav.Link href={Resume}>
              Resume
            </Nav.Link>
        
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavBar;